/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { EVENT_NAMES, PAGE_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import { patterns } from '@zcode/zumper-routes'
import { selectIsShortTermViewV1 } from '../../detail/modules/entity/selectors/index'
import type { Dispatch, GetState } from '../../types'
import type { PageName } from '../helpers'
import { getCommonProps } from '../helpers/getCommonProps'
import { getPreviousPage, setPreviousPage } from '../helpers/previousPageLocalStorage'

interface ViewPageProps {
  pageName: PageName
  extraPayload?: {}
  leaseLengthType?: string
}

export const mixpanelViewPage =
  ({ extraPayload = {}, pageName }: ViewPageProps) =>
  (dispatch: Dispatch, getState: GetState) => {
    let prevPage: string = getPreviousPage()
    if (document?.referrer) {
      if (
        patterns.messagesPath.test(document.referrer) &&
        pageName === PAGE_NAMES.DETAIL &&
        window?.history?.length === 1
      ) {
        // check if referrer is renter IAM, where renter clicked to view the detail page.
        prevPage = PAGE_NAMES.CHAT_SCREEN
      }
    }
    const state = getState()
    const isShortTermViewV1 = selectIsShortTermViewV1(state)
    const leaseLength = isShortTermViewV1 ? 'Short Term' : 'Long Term'
    const withLeaseLength = !(
      pageName === PAGE_NAMES.RENTAL_TYPE || pageName === PAGE_NAMES.HOMEPAGE
    )
    const payload = {
      [PROP_NAMES.PREVIOUS_PAGE]: prevPage,
      ...(withLeaseLength && { [PROP_NAMES.LEASE_LENGTH_TYPE]: leaseLength }),
      ...getCommonProps({ state, pageName, event: EVENT_NAMES.VIEW_PAGE }),
      ...extraPayload,
    }

    track({ event: EVENT_NAMES.VIEW_PAGE, payload })
    setPreviousPage(pageName)
  }
